import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { store } from './store';
import App from './App';
import './index.scss';
import { GTM_TAGID } from './constants/Config';

const tagManagerArgs = {
  gtmId: GTM_TAGID,
};
// Intialize the Google Tag Manager
TagManager.initialize(tagManagerArgs);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);
